import React, { useContext } from 'react';
import { ServiceCatalogItem } from '../../types';
import { DisplayText, PositiveNumberField } from '@superops/ui-design-system';
import { FormattedMessage, useIntl } from 'react-intl';
import { getTranslatedText, CurrencyField } from '@nile/components';
import { ServiceCatalogFormContext } from '../index';
import { isEmpty } from 'lodash';

function HourTypeItem({
  selectedCatalogItem,
  handlePropertyChange,
  disableServiceCatalogItemCostAndPrice
}: {
  selectedCatalogItem: ServiceCatalogItem;
  handlePropertyChange: (key, val) => void;
  disableServiceCatalogItemCostAndPrice: boolean;
}): React.ReactElement {
  const intl = useIntl();
  const { errors, currencyValue, currencyCode } = useContext(
    ServiceCatalogFormContext
  );

  function handleSellingPriceChange(key) {
    return (value) =>
      handlePropertyChange('sellingPrice', {
        ...selectedCatalogItem?.sellingPrice,
        model: 'PER_UNIT',
        details: [
          {
            ...selectedCatalogItem?.sellingPrice?.details[0],
            [key]: value || null
          }
        ]
      });
  }

  function handleRoundUpValueChange(value) {
    handlePropertyChange('serviceTypeItem', {
      ...selectedCatalogItem?.serviceTypeItem,
      hourlyServiceTypeItem: {
        ...selectedCatalogItem?.serviceTypeItem?.hourlyServiceTypeItem,
        roundUpValue: isEmpty(value) ? null : value
      }
    });
  }

  return (
    <div className="grid g20">
      <DisplayText>
        <FormattedMessage id="admin.serviceCatalog.offeringType.hour.note" />
      </DisplayText>
      <div className="fx actr g20">
        <CurrencyField
          size="small"
          showCurrency
          currencyInPrefix={false}
          placeholder="0"
          autoComplete="off"
          label={getTranslatedText(
            intl,
            'admin.serviceCatalog.offeringType.hour.business.hours'
          )}
          onChange={handleSellingPriceChange('value')}
          value={selectedCatalogItem?.sellingPrice?.details[0]?.value || ''}
          error={
            (errors?.['sellingPrice.details']?.[0] ||
              errors?.['sellingPrice']?.[0]) && (
              <FormattedMessage id="Business hour value cannot be empty" />
            )
          }
          onBlur={() => {
            if (
              selectedCatalogItem?.sellingPrice?.details[0]?.value.includes('.')
            ) {
              handleSellingPriceChange('value')(
                parseFloat(
                  selectedCatalogItem?.sellingPrice?.details[0]?.value
                ).toFixed(2)
              );
            }
          }}
          disabled={disableServiceCatalogItemCostAndPrice}
        />
        <CurrencyField
          size="small"
          showCurrency
          currencyInPrefix={false}
          placeholder="0"
          autoComplete="off"
          label={getTranslatedText(
            intl,
            'admin.serviceCatalog.offeringType.hour.after.hours'
          )}
          onChange={handleSellingPriceChange('afterHoursValue')}
          value={selectedCatalogItem?.sellingPrice?.details[0]?.afterHoursValue}
          disabled={disableServiceCatalogItemCostAndPrice}
        />
      </div>
      <PositiveNumberField
        type="number"
        label={getTranslatedText(intl, 'admin.serviceCatalog.roundupTime')}
        size="small"
        placeholder="1"
        suffix={getTranslatedText(intl, 'admin.serviceCatalog.roundup.units')}
        value={selectedCatalogItem?.serviceTypeItem?.hourlyServiceTypeItem?.roundUpValue?.toString()}
        autoComplete="off"
        onChange={handleRoundUpValueChange}
        onBlur={() => {
          if (
            selectedCatalogItem?.serviceTypeItem?.hourlyServiceTypeItem
              ?.roundUpValue === null
          ) {
            handleRoundUpValueChange('1');
          }
        }}
        disabled={disableServiceCatalogItemCostAndPrice}
      />
    </div>
  );
}

export default HourTypeItem;
